module.exports = __webpack_public_path__ + "img/background_kiosk.7e6e8111.png";